/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedExperienceDayPagedData } from '../../models/planned-experience-day-paged-data';

export interface GetStudentPlannedExperienceDays$Params {
  profileId: string;
  ExperienceDayId?: string;
  PendingOnly?: boolean;
  ConfirmedOnly?: boolean;
  PageNumber?: number;
  PageSize?: number;
}

export function getStudentPlannedExperienceDays(http: HttpClient, rootUrl: string, params: GetStudentPlannedExperienceDays$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedExperienceDayPagedData>> {
  const rb = new RequestBuilder(rootUrl, getStudentPlannedExperienceDays.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('ExperienceDayId', params.ExperienceDayId, {});
    rb.query('PendingOnly', params.PendingOnly, {});
    rb.query('ConfirmedOnly', params.ConfirmedOnly, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedExperienceDayPagedData>;
    })
  );
}

getStudentPlannedExperienceDays.PATH = '/studentprofile/{profileId}/plannedexperienceday';
